import { FormUnit, type Result } from "@suse-o11y/signal/form";
import { parse, stringify } from "yaml";

import { isShallowEqual } from "~/tools/is-shallow-equal";
import { tryCatch } from "~/tools/try-catch";

import { DashboardSpec } from "../../common/dashboard-spec";

export type DrawerState = FormUnit<string, null | ReadonlyArray<string>, DashboardSpec>;

export function initEditDrawerState(spec: DashboardSpec): DrawerState {
	const yaml = stringify(spec.toPerses());

	return FormUnit(yaml, {
		isErrorEqual: isShallowEqual,
		validate: (input): Result<null | ReadonlyArray<string>, DashboardSpec> => {
			const [, json] = tryCatch((): unknown => parse(input));

			const result = DashboardSpec.schema.safeParse(json);

			if (result.success) {
				return [null, result.data];
			}

			return [result.error.errors.map(({ message, path }) => `${path.join(".")}: ${message}`), null];
		},
	});
}
